import Link from '@/components/Common/Link'
import { INDSTOCKS_HOST } from '@/root/constants/common'
import AppRating from '../AppRating'
import MobileStores from '../MobileStores'
import Logo from './Logo'
import MainNav1 from './MainNav'

const LogoSocialLinksAppStoreIcons = ({ host }: { host?: string }) => {
  return (
    <div className="mb-10 w-full">
      <div className="mb-3 lg:mb-5">
        <Logo />
      </div>
      <div className="mb-4 flex flex-col gap-2 md:mb-6 md:w-4/5 lg:w-3/5">
        <MobileStores cssStyle="!flex-row" host={host} />
        <AppRating host={host} />
      </div>
    </div>
  )
}

export default function INDStocksFooter({ host }: { host?: string }) {
  return (
    <footer className="bg-brand-black text-13px text-brand-white">
      {/* <div className="flex flex-col md:flex-row max-w-7xl mx-auto pt-11 px-6 md:px-auto md:pt-26 md:pb-10"> */}
      <div className="herolike-wrapper pt-11 md:pb-10 md:pt-26">
        <aside className="flex w-full flex-col md:flex-row md:space-x-5">
          <div className="flex w-full flex-col md:w-1/2">
            <LogoSocialLinksAppStoreIcons host={INDSTOCKS_HOST} />
          </div>

          <div className="w-full md:w-1/2">
            <MainNav1 />
            <div className="mt-8">
              {' '}
              <p className="mb-4">
                INDstocks Private Limited (Formerly known as INDmoney Private
                Limited) is carrying out the business in respect to stock
                broking activities and also carries out the activities of
                depository participant. SEBI Registration No. INZ000305337 |
                SEBI Depository Participant Registration No. IN-DP-690-2022
                Depository Participant ID: CDSL 12095500 | Trading and Clearing
                Member of NSE (90267, M70042) and BSE, BSE Star MF (6779)| AMFI
                Registration No: ARN-254564| Registered Office - 616, 6th Floor
                Suncity Success Tower, Sector 65, Gurugram, Haryana-122005 | CIN
                U67100HR2021PTC098653 | Compliance officer: Ameya Mahendra
                Bhelekar, Contact No: 07314852049
              </p>
              <p className="mb-4">All Rights Reserved | © Copyright 2026</p>
              <p className="mb-4">
                Investment in securities market are subject to market risks,
                read all the related documents carefully before investing.
                Brokerage will not exceed the SEBI prescribed limit.
              </p>
              <p className="mb-4">
                Mutual Fund investments are subject to market risks, read all
                scheme related documents carefully before investing. INDstocks
                Private Limited is merely acting as a distributor of Mutual
                Funds and all disputes with respect to the distribution
                activity, would not have access to Exchange investor redressal
                forum or Exchange Arbitration mechanism.
              </p>
              <p className="mb-4">
                INDstocks makes no warranties or representations, express or
                implied, on products and services offered through the platform.
                It accepts no liability for any damages or losses, however,
                caused in connection with the use of, or on the reliance of its
                advisory or related services.
              </p>
              <p className="mb-4">
                Past performance is not indicative of future returns. Please
                consider your specific investment requirements, risk tolerance,
                goal, time frame, risk and reward balance and the cost
                associated with the investment before choosing a fund, or
                designing a portfolio that suits your needs. Performance and
                returns of any investment portfolio can neither be predicted nor
                guaranteed.
              </p>
              <p className="mb-4">
                INDstocks Private Limited (Formerly known as INDmoney Private
                Limited) -{' '}
                <Link
                  href="https://www.indstocks.com/page/raserviceunit"
                  className="text-brand-blue-azureRadiance"
                  target="_blank"
                >
                  Research Analyst Services Unit
                </Link>{' '}
                (Separately Identifiable Unit) INDmoney Private Limited|
                Research Analyst Registration No. INH000018948| BSE RA
                Enlistment No. 6428 |Compliance Officer: Hardeep Singh Arora|
                Registered Office - 616, 6th Floor Suncity Success Tower, Sector
                65, Gurugram, Haryana-122005 | CIN U67100HR2021PTC098653 |
                Email:{' '}
                <Link
                  href="mailto:rasupport@indmoney.com"
                  className="text-brand-blue-azureRadiance"
                  target="_blank"
                >
                  rasupport@indmoney.com
                </Link>{' '}
                Registration granted by SEBI, membership of a SEBI recognized
                supervisory body, and certification from NISM in no way
                guarantee performance of the intermediary or provide any
                assurance of returns to investors.
                <Link
                  href="https://www.indstocks.com/page/research-analyst-disclaimer"
                  className="text-brand-blue-azureRadiance"
                  target="_blank"
                >
                  Full RA Disclaimer
                </Link>{' '}
              </p>
              <p>
                Dear Investor,
                <br />
                SEBI has established an Online Dispute Resolution Portal (ODR
                Portal) for resolving disputes in the Indian Securities Market.
                The{' '}
                <Link
                  className="text-brand-blue-azureRadiance"
                  openInNewTab
                  href="https://www.sebi.gov.in/legal/circulars/jul-2023/online-resolution-of-disputes-in-the-indian-securities-market_74794.html"
                >
                  circular
                </Link>{' '}
                streamlines the existing dispute resolution mechanism, offering
                online conciliation and arbitration, benefiting investors and
                listed companies. ODR portal for Investors -{' '}
                <Link
                  openInNewTab
                  className="text-brand-blue-azureRadiance"
                  href="https://smartodr.in/login"
                >
                  https://smartodr.in/login
                </Link>
                <br />
                As you are aware, under the rapidly evolving dynamics of
                financial markets, it is crucial for investors to remain updated
                and well-informed about various aspects of investing in
                securities market. In this connection, please find a link to the
                BSE Investor Protection Fund website where you will find some
                useful educative material in the form of text and videos, so as
                to become an informed investor.
              </p>
              <Link
                className="text-brand-blue-azureRadiance"
                openInNewTab
                href="https://www.bseipf.com/investors_education.html"
              >
                https://www.bseipf.com/investors_education.html
              </Link>
              <p className="mb-4">
                We believe that an educated investor is a protected investor !!!
              </p>
              <p className="mb-4">
                Entities trading in securities of recognised / Listed stock
                exchanges, depositories, and clearing corporations must comply
                with the{' '}
                <Link
                  className="font-semibold text-brand-blue-azureRadiance"
                  openInNewTab
                  href="/page/fit-and-proper"
                >
                  'Fit and Proper'
                </Link>{' '}
                criteria as per SCRA, 1956 and applicable regulations."
              </p>
              <p>
                Dear Investors you can now access your disaggregated collateral
                details via ICCL's web based facility click{' '}
                <Link
                  className="text-brand-blue-azureRadiance"
                  openInNewTab
                  href="https://www.icclindia.com/DynamicPages/UCCDetails.aspx"
                >
                  here
                </Link>{' '}
                with a quick online registration
              </p>
            </div>
          </div>
        </aside>
      </div>
    </footer>
  )
}
